var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 93,
    viewBox: "0 0 154 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19833 41.918C-0.452126 19.6155 15.1375 -0.207879 32.5116 1.02127C43.5507 -1.46286 102.402 14.8292 132.356 18.0383C162.311 21.2474 139.655 56.7512 149.033 69.767C156.536 80.1796 150.684 92.0705 145.291 92.1249C146.958 89.1426 143.44 71.6964 107.097 65.2742C70.7536 58.8521 2.8488 64.2205 1.19833 41.918Z",
    stroke: "#775835",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.4bf1ed006e9a709e175f44cf1814c6a7.svg";
export { ForwardRef as ReactComponent };